import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_11: FaireProductEntity = {
  token: "matcha-11",
  type: "product",
  name: "Hikari Ceremonial Matcha",
  brandName: "Hikari",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/765ab09492060f5d7698f9ba182d659ce4fc4c63bf37148d6bba6109ae2e9f67.png",
  priceDollars: 3,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/765ab09492060f5d7698f9ba182d659ce4fc4c63bf37148d6bba6109ae2e9f67.png",
  weight: 0.2,
  dimensions: {
    width: 3,
    height: 5,
    depth: 2,
  },
  description: "Hikari ceremonial grade matcha",
  categoryTokens: ["cat_food-beverages"],
  tags: ["matcha", "tea", "japanese-green-tea", "ceremonial", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
